import axios from "axios";
import { useQuery } from "react-query";

const useGetCompanyTypeData = (id) => {
  // Always call hooks at the top level
  const { data, isLoading, error, refetch } = useQuery(
    ["companyTypeData", id],
    () => axios.get(`company_type/get_companyType/${id}`),
    {
      enabled: !localStorage.getItem("companyTypeData"), // Only fetch if not in localStorage
    }
  );

  let companyTypeData = localStorage.getItem("companyTypeData");
  if (companyTypeData) {
    return {
      data: JSON.parse(companyTypeData),
      isLoading: false,
      error: false,
      refetch: () => {},
    };
  } else {
    return { data, isLoading, error, refetch };
  }
};

export default useGetCompanyTypeData;


